<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
import { AdministrativeState } from '~~/interfaces/station'
import type { PoolStation } from '~~/interfaces/station'
import type { PropType } from 'vue'

const props = defineProps({
    stationId: {
        type: Number,
        required: true
    },
    station: {
        type: Object as PropType<PoolStation>,
        required: true
    }
})

const stationStatus = computed<AdministrativeState>(() => {
    if (
        props.station.administrativeState?.id === AdministrativeState.IN_SERVICE
    ) {
        return AdministrativeState.IN_SERVICE
    }

    return AdministrativeState.OUT_OF_SERVICE
})

const onStationChange = (event: Event) => {
    usePoolStore().updateStation(
        Number((event.target as HTMLInputElement)?.value) || 0,
        props.stationId
    )
}
</script>

<template>
    <div class="w-full flex">
        <div
            class="w-full bg-[#FEF3C8] gap-y-1 rounded-lg py-2 px-4 text-xs min-h-50 flex items-center font-medium flex-wrap mb-2"
        >
            <div>
                <span class="text-[#DB7706]">
                    {{ $t('station.singular').toUpperCase() }}&nbsp;
                </span>
                <span class="text-[#91400D]">#{{ station.id }}</span>
            </div>
            <div>
                <select
                    class="rounded-lg p-1 border-1 border-gray-l-300"
                    :value="stationStatus"
                    @change="onStationChange"
                >
                    <option value="4">{{ $t('pool.in_service') }}</option>
                    <option value="5">
                        {{ $t('plug.state.out_of_service') }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>
